import { useState } from 'react';
import { useScopedTranslation } from '../../application/localization/useScopedTranslation.ts';
import styles from './ForgotPasswordPage.module.scss';
import Logo from '../../assets/img/logo.svg?react';

import { Input } from '../../components/uikit/inputs/Input.tsx';
import { Button, ButtonColor } from '../../components/uikit/buttons/Button.tsx';
import { AppLink } from '../../components/uikit/buttons/AppLink.tsx';
import { UserClient } from 'services/api/api-client.ts';
import {
  LoadingPage,
  LoadingType,
} from '../../components/animations/LoadingPage.tsx';
import { useNavigate } from 'react-router';
import { StringParam, useQueryParams } from 'react-router-url-params';
import { UnauthorizedPageRoot } from './UnauthorizedPageRoot.tsx';

export const ForgotPasswordPage = () => {
  const [params, _] = useQueryParams({
    username: StringParam,
  });
  const [emailOrLogin, setEmailOrLogin] = useState(params.username ?? '');
  const [inputError, setInputError] = useState('');
  const [loadingStatus, setlLoadingStatus] = useState<LoadingType>('none');

  const navigate = useNavigate();

  const handleBackToLogin = () => {
    setlLoadingStatus('none');
    void navigate('/');
  };

  const i18n = useScopedTranslation('Page.ForgotPassword');
  const handleSubmit = async () => {
    if (!emailOrLogin.trim()) {
      setInputError(i18n.t('required_error'));
      return;
    }
    setlLoadingStatus('loading');
    void UserClient.sendResetPasswordEmail(emailOrLogin).finally(() =>
      setlLoadingStatus('completed'),
    );
  };
  return (
    <>
      {loadingStatus !== 'none' ? (
        <>
          <div className={styles.headerWrapper}>
            <AppLink to={'/'}>
              <div className={styles.lmtLogo}>
                <Logo />
              </div>
            </AppLink>
          </div>
          <LoadingPage
            loadingStatus={loadingStatus}
            titleLoadingContent={<div>{i18n.t('submit_loading_title')}</div>}
            titleContent={<div>{i18n.t('submit_completed_title')}</div>}
            bodyContent={
              <div>
                {i18n.t('submit_completed_text', {
                  user_email: `${emailOrLogin}`,
                })}
              </div>
            }
            footerContent={
              <Button
                title={i18n.t('submit_completed_button')}
                color={ButtonColor.Secondary}
                onClick={handleBackToLogin}
              />
            }
          />
        </>
      ) : (
        <UnauthorizedPageRoot>
          <div className={styles.loginTitle}>{i18n.t('title')}</div>
          <div className={styles.text}>{i18n.t('text')}</div>
          <Input
            value={emailOrLogin}
            errorText={inputError}
            onChange={(e) => {
              setEmailOrLogin(e.target.value);
              setInputError('');
            }}
            onEnterPressed={handleSubmit}
            className={styles.input}
            topHelperText={i18n.t('input_label')}
          ></Input>
          <Button
            onClick={handleSubmit}
            className={styles.button}
            title={i18n.t('submit_button')}
          ></Button>
        </UnauthorizedPageRoot>
      )}
    </>
  );
};
